/**
 * 销售模块及顶栏中英文文案
 */
export default {
  zh: {
    'nav.productSales': '清单销售',
    'nav.order': '订单记录',
    'nav.customer': '客户查询',
    'nav.commodity': '商品',
    'header.orgInfo': '机构信息：',
    'header.orgSetting': '机构设置',
    'header.logout': '退出',
    'lang.zh': '中文',
    'lang.en': 'EN',

    'sale.login.title': '救援服务销售平台',
    'sale.login.account': '登录账号:',
    'sale.login.accountPh': '请输入登录账号',
    'sale.login.accountRequired': '请输入登录账号',
    'sale.login.password': '密码:',
    'sale.login.passwordPh': '请输入机构密码',
    'sale.login.passwordRequired': '请输入密码',
    'sale.login.captcha': '验证码:',
    'sale.login.captchaPh': '请输入验证码',
    'sale.login.captchaRequired': '请输入验证码',
    'sale.login.captchaAlt': '验证码',
    'sale.login.submit': '登录销售平台',
    'sale.login.apply': '注册',
    'sale.login.orgName': '机构名称:',
    'sale.login.orgNamePh': '请输入机构名称',
    'sale.login.orgNameRequired': '请输入机构名称！',
    'sale.login.contactName': '联系人姓名:',
    'sale.login.contactNamePh': '请输入联系人姓名',
    'sale.login.contactNameRequired': '请输入联系人姓名！',
    'sale.login.contactPhone': '联系人电话:',
    'sale.login.contactPhonePh': '请输入联系人电话',
    'sale.login.phoneRequired': '电话不能为空！',
    'sale.login.phoneNumber': '请输入数字值',
    'sale.login.contactEmail': '联系人邮箱:',
    'sale.login.contactEmailPh': '请输入联系人邮箱',
    'sale.login.contactEmailRequired': '请输入联系人邮箱！',
    'sale.login.contactEmailInvalid': '请输入正确的邮箱格式',
    'sale.login.address': '机构地址:',
    'sale.login.addressPh': '请输入机构地址',
    'sale.login.addressRequired': '请输入地址！',
    'sale.login.orgCode': '组织机构代码:',
    'sale.login.orgCodePh': '请输入组织机构代码',
    'sale.login.branch': '办理中心地点:',
    'sale.login.branchPh': '请选择办理中心地点',
    'sale.login.branchRequired': '请选择办理中心地点！',
    'sale.login.visaCenter': '签证中心:',
    'sale.login.visaCenterPh': '请选择签证中心',
    'sale.login.visaCenterRequired': '请选择签证中心！',
    'sale.login.channelListEmpty': '该办理中心暂无可选签证中心',
    'sale.login.applyPasswordPh': '请设置登录密码',
    'sale.login.passwordMin': '密码不能小于6位',
    'sale.login.applySuccess': '注册成功，请使用邮箱和密码登录',
    'sale.login.goLogin': '已有账号，去登录',
    'sale.footer.terms': '条款条约 Terms & Conditions',
    'sale.footer.privacy': '隐私政策 Privacy Policy',
    'sale.footer.contact': '联系我们 Contact Us',
    'sale.footer.return': '退换货政策 Return Policy',
    'sale.footer.ip': '知识产权 Intellectual Property Rights',
    'api.msg.验证码不正确': '验证码不正确',
    'api.msg.验证码错误': '验证码错误',
    'api.msg.图片验证码错误': '图片验证码错误',
    'api.msg.验证码已失效': '验证码已失效',
    'api.msg.验证码已失效，请重新获取': '验证码已失效，请重新获取',
    'api.msg.请输入验证码': '请输入验证码',
    'api.msg.用户名或密码错误': '用户名或密码错误',
    'api.msg.账号或密码错误': '账号或密码错误',
    'api.msg.密码错误': '密码错误',
    'api.msg.账号不存在': '账号不存在',
    'api.msg.账号已经锁定了': '账号已经锁定了',
    'api.msg.账号已锁定': '账号已锁定',
    'api.msg.登录失败': '登录失败',
    'api.msg.登录错误次数过多，请输入验证码': '登录错误次数过多，请输入验证码',
    'api.msg.输入密码错误次数过多': '输入密码错误次数过多',
    'api.msg.操作失败': '操作失败',
    'api.msg.系统繁忙，请稍后再试': '系统繁忙，请稍后再试',
    'api.msg.参数错误': '参数错误',
    'api.msg.余额不足': '余额不足',
    'api.msg.充值方式不能叠加使用': '充值方式不能叠加使用',
    'api.msg.年龄不在保障范围内': '年龄不在保障范围内',
    'api.msg.已获取权益无法重复领取': '已获取权益无法重复领取',
    'api.msg.请检查预存账户余额等信息': '请检查预存账户余额等信息',
    'api.msg.账户退款审核中': '账户退款审核中',
    'api.msg.获取权益成功': '获取权益成功',
    'api.msg.请检查保障开始时间是否正常': '请检查保障开始时间是否正常',
    'api.msg.申请成功，请您耐心等待我们后台审核通过！': '申请成功，请您耐心等待我们后台审核通过！',
    'api.msg.注册失败': '注册失败',

    'sale.productSales.title': '清单销售',
    'sale.productSales.desc': '单人购买系统出单',
    'sale.productSales.product': '购买产品',
    'sale.productSales.plan': '购买方案',
    'sale.productSales.batchName': '批次名称',
    'sale.productSales.channel': '销售渠道',
    'sale.productSales.addSingle': '添加保障用户',
    'sale.productSales.upload': '上传',
    'sale.productSales.downloadTpl': '(下载模板)',
    'sale.productSales.addCardOnly': '添加仅卡号',
    'sale.productSales.selectProduct': '请选择购买产品',
    'sale.productSales.selectPlan': '请选择购买方案',
    'sale.productSales.inputBatch': '请输入批次名称',
    'sale.productSales.selectChannel': '请选择销售渠道',
    'sale.productSales.selectedProduct': '当前产品',
    'sale.productSales.changeProduct': '其他方案',
    'sale.productIntro.title': '产品介绍',
    'sale.productIntro.desc': '选择产品并查看保障权益后进入销售',
    'sale.productIntro.selectProduct': '购买产品',
    'sale.productIntro.currentProduct': '当前产品',
    'sale.productIntro.rescueRights': '救援权益保障',
    'sale.productIntro.insureRights': '保险权益【赠送】',
    'sale.productIntro.coverAge': '保障年龄',
    'sale.productIntro.coverPeriod': '保障期限',
    'sale.productIntro.ageUnit': '岁',
    'sale.productIntro.ageRange': '{min}~{max}岁',
    'sale.productIntro.unitYear': '年',
    'sale.productIntro.unitMonth': '月',
    'sale.productIntro.unitDay': '日',
    'sale.productIntro.fee': '费用',
    'sale.productIntro.feeFrom': '{n}元/起',
    'sale.productIntro.expand': '展开更多',
    'sale.productIntro.collapse': '收起',
    'sale.productIntro.startSale': '立即购买',
    'sale.productIntro.buyNotice': '您购买的救援服务清单所对应的保障服务期以救援服务清单凭证中保障的起止日期为准。在保障期限内，无论您是否联系江泰救援进行咨询、是否实际使用救援服务，亦或是否启动了附赠保险保障，均视作本清单项下全部保障服务已履约完成，清单费用不予退还，祝您平安无忧。',
    'sale.productIntro.empty': '暂无可售产品',
    'sale.productIntro.noRights': '暂无权益介绍',
    'sale.productIntro.loadFail': '产品列表加载失败',
    'sale.productIntro.detailFail': '产品详情加载失败',
    'sale.summary.totalQty': '出单总销售数量',
    'sale.summary.totalAmount': '出单总计待支付金额',
    'sale.summary.submit': '提交出单',
    'sale.agree.prefix': '我已知晓救援服务清单全部内容并同意江泰救援赠送的保险保障及保额（如有）并同意',
    'sale.agree.insureClause': '保险条款',
    'sale.agree.rescueDetail': '救援权益详情',
    'sale.agree.healthDetail': '健康权益详情',
    'sale.agree.detail': '详情',
    'sale.agree.empty': '暂无内容',
    'sale.agree.loadFail': '加载须知失败',
    'sale.agree.requireCheck': '请勾选并确认已阅读相关须知',
    'sale.agree.openPdf': '新窗口打开',
    'sale.agree.invalidLink': '无法打开该链接',
    'sale.summary.listTitle': '保障用户列表',
    'sale.summary.listCount': '共 {n} 人',
    'sale.confirm.title': '确认提交',
    'sale.confirm.listTitle': '销售清单',
    'sale.confirm.totalQty': '当前总销售数量',
    'sale.confirm.standardAmount': '标准销售金额',
    'sale.confirm.noChange': '确认后不可更改',
    'sale.purchaseSuccess.title': '购买成功',
    'sale.purchaseSuccess.desc': '您的订单已提交成功，可前往订单记录查看详情。',
    'sale.purchaseSuccess.viewOrder': '点击查看订单',
    'sale.billing.title': '消费者信息',
    'sale.billing.firstName': '名',
    'sale.billing.firstNamePh': '请输入名',
    'sale.billing.firstNameRequired': '请输入名',
    'sale.billing.lastName': '姓',
    'sale.billing.lastNamePh': '请输入姓',
    'sale.billing.lastNameRequired': '请输入姓',
    'sale.billing.email': '邮箱',
    'sale.billing.emailPh': '请输入邮箱',
    'sale.billing.emailRequired': '请输入邮箱',
    'sale.billing.emailInvalid': '请输入正确的邮箱格式',
    'sale.billing.phone': '电话',
    'sale.billing.phonePh': '请输入电话',
    'sale.billing.phoneRequired': '请输入电话',
    'sale.common.yuan': '元',
    'sale.common.yuanFrom': '元/起',

    'sale.order.title': '订单记录',
    'sale.order.desc': '客户保障查询',
    'sale.order.inquiry': '保障查询',
    'sale.order.saleTime': '销售时间',
    'sale.order.settleStatus': '结算状态',
    'sale.order.channel': '销售渠道',
    'sale.order.visaCenter': '签证中心',
    'sale.order.payType': '付款方式',
    'sale.order.search': '搜索',
    'sale.order.export': '导出',
    'sale.order.list': '订单列表',
    'sale.order.total': '共 {n} 条',
    'sale.common.all': '全部',
    'sale.common.unsettled': '未结算',
    'sale.common.settled': '已结算',
    'sale.common.startDate': '开始日期',
    'sale.common.endDate': '结束日期',
    'sale.common.none': '无',
    'sale.common.unitGe': '个',
    'sale.common.loading': '加载中...',
    'sale.common.to': '至',
    'sale.common.empty': '暂无数据',

    'sale.customer.title': '客户查询',
    'sale.customer.desc': '客户保障查询',
    'sale.customer.name': '姓名',
    'sale.customer.idNo': '证件号',
    'sale.customer.inputName': '请输入姓名',
    'sale.customer.inputIdNo': '请输入证件号',
    'sale.customer.list': '客户列表',
    'sale.customer.pendingActive': '待激活',
    'sale.customer.copyCode': '点击复制激活卡号',
    'sale.customer.copyActiveUrl': '复制激活地址',
    'sale.customer.viewQr': '查看二维码',
    'sale.customer.activated': '已激活',
    'sale.customer.activateFirst': '请先激活',

    'sale.commodity.title': '商品',
    'sale.commodity.desc': '已签约商品（仅展示非结算价商品）',
    'sale.commodity.productName': '产品名',
    'sale.commodity.groupCode': '组编号',
    'sale.commodity.inputName': '请输入产品名',
    'sale.commodity.select': '请选择',
    'sale.commodity.payMode': '出单支付',
    'sale.commodity.normalPay': '正常支付',
    'sale.commodity.prestore': '预存购买',
    'sale.commodity.anonymous': '不记名核销',
    'sale.commodity.search': '搜索',
    'sale.commodity.coverAge': '保障年龄：',
    'sale.commodity.noLimit': '无限制',
    'sale.commodity.within': '以内',
    'sale.commodity.coverDate': '保障日期：',
    'sale.commodity.fee': '费用：',
    'sale.commodity.feeValue': '{n}元',
    'sale.commodity.channelSelect': '渠道选择',
    'sale.commodity.downloadQr': '下载二维码',
    'sale.commodity.qrFileName': '快捷购买二维码',
    'sale.commodity.unitYear': '年',
    'sale.commodity.unitMonth': '月',
    'sale.commodity.unitDay': '日',
    'sale.commodity.expired': '已过期',
    'sale.commodity.expiredTag': '(已过期)',
    'sale.commodity.deadline': '截止日期：',
    'sale.commodity.remainCount': '剩余张数：',
    'sale.commodity.unitZhang': '张',
    'sale.commodity.empty': '暂无签约',

    'sale.detail.title': '订单详情',
    'sale.detail.batch': '批次：',
    'sale.detail.back': '返回',
    'sale.detail.orderInfo': '订单信息',
    'sale.detail.coverage': '保障明细',
    'sale.detail.seller': '出售人',
    'sale.detail.productList': '订购清单',
    'sale.detail.financeStatus': '财务状态',
    'sale.detail.saleTime': '出售时间',
    'sale.detail.orderNo': '订单号',
    'sale.detail.buyQty': '购买数量',
    'sale.detail.referrer': '推荐人',
    'sale.detail.decorationCo': '装修公司',
    'sale.detail.decorationAddr': '装修地址',
    'sale.detail.houseNo': '门牌号',
    'sale.detail.contractAmount': '装修合同金额',
    'sale.detail.download': '下载',
    'sale.detail.groupCredential': '团单凭证',
    'sale.detail.groupCredentialEdit': '团单凭证(批改)',
    'sale.detail.groupCredentialReduce': '团单凭证(批减)',
    'sale.detail.credentialType': '凭证类型',
    'sale.detail.genDate': '生成日期',

    'col.index': '序号',
    'col.id': 'ID',
    'col.name': '姓名',
    'col.insuredName': '被保人姓名',
    'col.userName': '用户姓名',
    'col.mobile': '手机号',
    'col.idNo': '证件号码',
    'col.idInfo': '证件信息',
    'col.birthday': '出生日期',
    'col.sex': '性别',
    'col.email': '邮箱地址',
    'col.flightNo': '航班/车次号',
    'col.flightNo2': '航班号/车次',
    'col.op': '操作',
    'col.days': '天数',
    'col.activateDate': '出行开始时间',
    'col.entryTime': '进入中国大陆边境时间',
    'col.leaveTime': '离开中国大陆边境时间',
    'col.validFrom': '保障开始日期',
    'col.validUtil': '保障结束日期',
    'col.insuranceStart': '保险起期',
    'col.country': '外派国家',
    'col.product': '商品',
    'col.productName': '产品名称',
    'col.qty': '数量',
    'col.orderNo': '订单号',
    'col.channel': '渠道',
    'col.amount': '付款金额',
    'col.payMethod': '支付方式',
    'col.status': '状态',
    'col.createTime': '出单时间',
    'col.cardNo': '保障卡号',
    'col.policyNo': '保单号',
    'col.activateUrl': '激活地址',
    'col.company': '所属集体二级企业',
    'col.insureName': '投保人',
    'col.project': '项目名称',
    'col.occupation': '职业',
    'col.month': '投保月份',
    'col.remark': '备注',
    'col.startPeriod': '起期',
    'col.endPeriod': '止期',
    'col.amountYuan': '金额(元)',
    'col.userNameShort': '用户名',
    'col.idNoShort': '证件号',

    'op.detail': '查看详情',
    'op.refund': '退单',
    'op.viewCredential': '查看凭证',
    'op.genCredential': '正在生成凭证',
    'op.generating': '生成中',
    'op.downloadCredential': '凭证下载',
    'op.edit': '编辑',
    'op.delete': '删除',
    'op.view': '查看',
    'op.submit': '提交',
    'op.cancel': '取 消',
    'op.confirm': '确 定',
    'op.modify': '修改',
    'op.refresh': '刷 新',

    'dialog.tip': '提示',
    'dialog.friendTip': '友情提示',
    'dialog.confirmRefund': '请确认退单？',
    'dialog.refundSuccess': '退单成功！',
    'dialog.refundFail': '退单失败！',
    'dialog.refundPartialFail': '部分退单失败！',
    'dialog.refundActivatedFail': '保障卡已激活不能退款！',
    'dialog.qrcode': '二维码',
    'dialog.payMethod': '支付方式',
    'dialog.selectPayMethod': '请选择本单支付方式',
    'dialog.orderConfirm': '订单确认',
    'dialog.repeatInfo': '重复信息',
    'dialog.confirmDelete': '确定删除',
    'dialog.deleteWarn': '确定后不可恢复？',
    'dialog.adjustAmount': '调整付款金额',
    'dialog.credentialDownload': '凭证下载',
    'dialog.addInsured': '添加保障用户',
    'dialog.editInfo': '修改信息',
    'dialog.warning': '警告',

    'form.userName': '用户姓名:',
    'form.travelType': '出行方式:',
    'form.flight': '航班号',
    'form.train': '火车',
    'form.resident': '用户常住地:',
    'form.residentPh': '请输入用户常驻地',
    'form.flightPh': '本产品只保障单次出行',
    'form.mobile': '联系人手机号:',
    'form.mobilePh': '请输入联系人手机号',
    'form.idType': '证件类型:',
    'form.idNo': '用户证件号:',
    'form.idNoPh': '输入护照号或其他证件号',
    'form.birthday': '出生日期:',
    'form.activateDate': '出行开始时间:',
    'form.entryTime': '进入中国大陆边境时间:',
    'form.entryTimePh': '请选择进入中国大陆边境时间',
    'form.leaveTime': '离开中国大陆边境时间:',
    'form.leaveTimePh': '请选择离开中国大陆边境时间',
    'form.borderTimeNote': '注：中国境内（除港澳台）',
    'form.selectDate': '选择日期',
    'form.days': '天数:',
    'form.daysPh': '请输入天数',
    'form.sex': '性别:',
    'form.male': '男',
    'form.female': '女',
    'form.email': '邮箱地址',
    'form.emailPh': '请输入邮箱地址',
    'form.emailRequired': '邮箱地址不能为空',
    'form.emailInvalid': '请输入正确的邮箱格式',
    'form.select': '请选择',
    'form.userNamePh': '请输入用户姓名',
    'form.userNameRequired': '用户姓名不能为空',
    'form.travelTypeRequired': '出行方式不能为空',
    'form.residentRequired': '常驻地不能为空',
    'form.flightNoRequired': '航班/车次号不能为空',
    'form.mobileRequired': '手机号不能为空',
    'form.idTypeRequired': '证件类型不能为空',
    'form.idNoRequired': '用户证件号不能为空',
    'form.birthdayRequired': '出生日期不能为空',
    'form.dateRequired': '日期不能为空',
    'form.daysRequired': '天数不能为空',
    'form.entryTimeRequired': '请选择进入中国大陆边境时间',
    'form.leaveTimeRequired': '请选择离开中国大陆边境时间',
    'form.sexRequired': '性别不能为空',
    'form.otherRequired': '其他不能为空',
    'form.sexIdMismatch': '性别与身份证不符',
    'form.idNoInvalid': '输入的身份证号有误，请检查后重新输入！',
    'form.addSuccess': '恭喜你，添加成功！',
    'form.travelStartAfterEntry': '出行开始时间应小于等于进入中国大陆边境时间',
    'form.selectedDaysExceedTravelSpan': '所选天数应大于等于出行开始时间至离开中国大陆边境时间的区间天数（含起止日共{n}天）',
    'form.leaveTimeBeforeTravel': '离开中国大陆边境时间不能早于出行开始时间',
    'form.daysMin': '不能低于{n}{unit}',
    'form.daysMax': '不能超过{n}{unit}',
    'form.daysMaxDays': '不能超过{n}天',
    'form.daysPlanRange': '天数需在{min}-{max}天区间',
    'form.idFormatInvalid': '身份证号码格式不正确，请重新输入！',
    'form.idAreaInvalid': '身份证号码地区码不正确，请重新输入！',
    'form.idBirthdayInvalid': '身份证号码出生日期不正确，请重新输入！',
    'form.idCheckDigitInvalid': '身份证号码校验位不正确，请重新输入！',
    'form.company': '所属集体二级企业:',
    'form.companyPh': '请输入所属集体二级企业',
    'form.insureName': '投保人:',
    'form.insureNamePh': '请输入投保人',
    'form.project': '项目名称:',
    'form.projectPh': '请输入项目名称',
    'form.occupation': '职业:',
    'form.occupationPh': '职业名称',
    'form.month': '投保月份:',
    'form.monthPh': '投保月份名称',
    'form.remark': '备注:',
    'form.remarkPh': '备注',
    'form.batchName': '批次名称',
    'form.channel': '销售渠道',
    'form.flightNoLabel': '航班/车次号:',

    'idType.1': '身份证',
    'idType.3': '护照',
    'idType.6': '港澳来往内地通行证或台胞证',
    'idType.9': '港澳台通行证',
    'idType.10': '港澳通行证',
    'idType.11': '往来台湾通行证',
    'idType.4': '其他',

    'pay.alipay': '支付宝',
    'pay.wechat': '微信',
    'pay.offline': '线下',
    'pay.prestore': '预存支付',
    'pay.normal': '正常支付',
    'pay.immediate': '立即支付',
    'pay.transfer': '转账',
    'pay.offlineTransfer': '线下转账',
    'pay.wechatPay': '微信支付',
    'pay.alipayPay': '支付宝支付',
    'pay.amountDue': '出单应付金额：',
    'pay.yuan': '元',
    'pay.wechatPayTip': '请使用微信完成付款',
    'pay.alipayPayTip': '请使用支付宝完成付款',
    'pay.validFromAbnormal': '请检查保障开始时间是否正常',
    'pay.rechargeNoStack': '充值方式不能叠加使用',
    'pay.insufficientBalance': '余额不足',
    'pay.ageOutOfRange': '年龄不在保障范围内',
    'pay.benefitAlreadyClaimed': '已获取权益无法重复领取',
    'pay.checkPrestoreAccount': '请检查预存账户余额等信息',
    'pay.refundAuditing': '账户退款审核中',
    'pay.paramError': '参数错误',
    'pay.benefitSuccess': '获取权益成功',
    'pay.gift': '赠送',
    'pay.split': '实时分账',
    'pay.online': '在线支付',

    'billing.0': '创建',
    'billing.1': '线上支付完成',
    'billing.2': '挂帐月结-未付',
    'billing.3': '线下转账-已付款',
    'billing.4': '已退单',
    'billing.5': '投保失败退单',
    'billing.5b': '投保失败-退单'
  },
  en: {
    'nav.productSales': 'Product List Sales',
    'nav.order': 'Order History',
    'nav.customer': 'Customer Search',
    'nav.commodity': 'Products',
    'header.orgInfo': 'Organization: ',
    'header.orgSetting': 'Settings',
    'header.logout': 'Log out',
    'lang.zh': 'Chinese',
    'lang.en': 'English',

    'sale.login.title': 'Rescue Service Sales Platform',
    'sale.login.account': 'Login Account:',
    'sale.login.accountPh': 'Enter login account',
    'sale.login.accountRequired': 'Please enter login account',
    'sale.login.password': 'Password:',
    'sale.login.passwordPh': 'Enter password',
    'sale.login.passwordRequired': 'Please enter password',
    'sale.login.captcha': 'Verification code:',
    'sale.login.captchaPh': 'Please enter the verification code',
    'sale.login.captchaRequired': 'Please enter the verification code',
    'sale.login.captchaAlt': 'Verification code',
    'sale.login.submit': 'Log in',
    'sale.login.apply': 'Register',
    'sale.login.orgName': 'Organization:',
    'sale.login.orgNamePh': 'Enter organization name',
    'sale.login.orgNameRequired': 'Please enter organization name',
    'sale.login.contactName': 'Contact Name:',
    'sale.login.contactNamePh': 'Enter contact name',
    'sale.login.contactNameRequired': 'Please enter contact name',
    'sale.login.contactPhone': 'Phone:',
    'sale.login.contactPhonePh': 'Enter contact phone',
    'sale.login.phoneRequired': 'Phone is required',
    'sale.login.phoneNumber': 'Please enter a number',
    'sale.login.contactEmail': 'Contact Email:',
    'sale.login.contactEmailPh': 'Enter contact email',
    'sale.login.contactEmailRequired': 'Please enter contact email',
    'sale.login.contactEmailInvalid': 'Please enter a valid email',
    'sale.login.address': 'Address:',
    'sale.login.addressPh': 'Enter organization address',
    'sale.login.addressRequired': 'Please enter address',
    'sale.login.orgCode': 'Org Code:',
    'sale.login.orgCodePh': 'Enter organization code',
    'sale.login.branch': 'Service Center:',
    'sale.login.branchPh': 'Select service center',
    'sale.login.branchRequired': 'Please select a service center',
    'sale.login.visaCenter': 'Visa Center:',
    'sale.login.visaCenterPh': 'Select visa center',
    'sale.login.visaCenterRequired': 'Please select a visa center',
    'sale.login.channelListEmpty': 'No visa centers available for this service center',
    'sale.login.applyPasswordPh': 'Set login password',
    'sale.login.passwordMin': 'Password must be at least 6 characters',
    'sale.login.applySuccess': 'Registration successful. Please log in with your email and password.',
    'sale.login.goLogin': 'Already have an account Log in',
    'sale.footer.terms': 'Terms & Conditions',
    'sale.footer.privacy': 'Privacy Policy',
    'sale.footer.contact': 'Contact Us',
    'sale.footer.return': 'Return Policy',
    'sale.footer.ip': 'Intellectual Property Rights',
    'api.msg.验证码不正确': 'Incorrect verification code',
    'api.msg.验证码错误': 'Incorrect verification code',
    'api.msg.图片验证码错误': 'Incorrect image captcha',
    'api.msg.验证码已失效': 'Verification code has expired',
    'api.msg.验证码已失效，请重新获取': 'Verification code has expired,please request a new one',
    'api.msg.请输入验证码': 'Please enter the verification code',
    'api.msg.用户名或密码错误': 'Incorrect username or password',
    'api.msg.账号或密码错误': 'Incorrect account or password',
    'api.msg.密码错误': 'Incorrect password',
    'api.msg.账号不存在': 'Account does not exist',
    'api.msg.账号已经锁定了': 'Account has been locked',
    'api.msg.账号已锁定': 'Account has been locked',
    'api.msg.登录失败': 'Login failed',
    'api.msg.登录错误次数过多，请输入验证码': 'Too many failed login attempts, please enter captcha',
    'api.msg.输入密码错误次数过多': 'Too many incorrect password attempts',
    'api.msg.操作失败': 'Operation failed',
    'api.msg.系统繁忙，请稍后再试': 'System is busy, please try again later',
    'api.msg.参数错误': 'Invalid parameters',
    'api.msg.余额不足': 'Insufficient balance',
    'api.msg.充值方式不能叠加使用': 'Recharge methods cannot be used together',
    'api.msg.年龄不在保障范围内': 'Age is outside the coverage range',
    'api.msg.已获取权益无法重复领取': 'Benefit already claimed and cannot be claimed again',
    'api.msg.请检查预存账户余额等信息': 'Please verify your prepaid account balance and information.',
    'api.msg.账户退款审核中': 'Account refund is under review',
    'api.msg.获取权益成功': 'Benefit obtained successfully',
    'api.msg.请检查保障开始时间是否正常': 'Please check whether the coverage start time is valid',
    'api.msg.申请成功，请您耐心等待我们后台审核通过！': 'Application submitted. Please wait for review.',
    'api.msg.注册失败': 'Registration failed',

    'sale.productSales.title': 'Sales List',
    'sale.productSales.desc': 'Single-person system issuance',
    'sale.productSales.product': 'Product',
    'sale.productSales.plan': 'Plan',
    'sale.productSales.batchName': 'Batch Name',
    'sale.productSales.channel': 'Channel',
    'sale.productSales.addSingle': 'Add Insured User',
    'sale.productSales.upload': 'Upload',
    'sale.productSales.downloadTpl': '(Template)',
    'sale.productSales.addCardOnly': 'Add Card Only',
    'sale.productSales.selectProduct': 'Select product',
    'sale.productSales.selectPlan': 'Select plan',
    'sale.productSales.inputBatch': 'Enter batch name',
    'sale.productSales.selectChannel': 'Select channel',
    'sale.productSales.selectedProduct': 'Selected',
    'sale.productSales.changeProduct': 'Other Plans',
    'sale.productIntro.title': 'Product Intro',
    'sale.productIntro.desc': 'Select a product and review benefits before selling',
    'sale.productIntro.selectProduct': 'Select a Product',
    'sale.productIntro.currentProduct': 'Current Product',
    'sale.productIntro.rescueRights': 'Emergency Assistance Coverage',
    'sale.productIntro.insureRights': 'Insurance Coverage',
    'sale.productIntro.coverAge': 'Age Limit',
    'sale.productIntro.coverPeriod': 'Coverage Period',
    'sale.productIntro.ageUnit': ' years old',
    'sale.productIntro.ageRange': '{min} - {max} years old',
    'sale.productIntro.unitYear': ' years',
    'sale.productIntro.unitMonth': ' months',
    'sale.productIntro.unitDay': ' days',
    'sale.productIntro.fee': 'Price',
    'sale.productIntro.feeFrom': 'From CNY {n}',
    'sale.productIntro.expand': 'Show more',
    'sale.productIntro.collapse': 'Collapse',
    'sale.productIntro.startSale': 'Buy Now',
    'sale.productIntro.buyNotice': 'The coverage period applicable to the rescue service package you have purchased shall be subject to the start and end dates specified in the rescue service package voucher. Within the coverage period, whether you consult Jiangtai Rescue, actually use rescue services, or activate the complimentary insurance coverage, all services under this package shall be deemed fully performed. No refund will be granted for the package fee. Wish you safety and peace.',
    'sale.productIntro.empty': 'No products available',
    'sale.productIntro.noRights': 'No benefits info',
    'sale.productIntro.loadFail': 'Failed to load products',
    'sale.productIntro.detailFail': 'Failed to load product details',
    'intro.name.魅力中国游（优选版）-江泰救援入境旅行救援服务清单': 'Charm of China Tour (Preferred Plan) - Jiangtai Assistance Inbound Travel Assistance Service Package',
    'intro.name.魅力中国游（尊享版）-江泰救援入境旅行救援服务清单': 'Charm of China Tour (Premium Plan) - Jiangtai Assistance Inbound Travel Assistance Service Package',
    'intro.name.魅力中国游优选版入境旅行救援服务清单方案一': 'Charm of China Tour (Preferred) – JT Travel China Insurance plan 1',
    'intro.name.魅力中国游优选版入境旅行救援服务清单方案二': 'Charm of China Tour (Preferred) – JT Travel China Insurance plan 2',
    'intro.name.魅力中国游优选版入境旅行救援服务清单方案三': 'Charm of China Tour (Preferred) – JT Travel China Insurance plan 3',
    'intro.name.魅力中国游尊享版入境旅行救援服务清单方案一': 'Charm of China Tour (Premium) – JT Travel China Insurance plan 1',
    'intro.name.魅力中国游尊享版入境旅行救援服务清单方案二': 'Charm of China Tour (Premium) – JT Travel China Insurance plan 2',
    'intro.name.魅力中国游尊享版入境旅行救援服务清单方案三': 'Charm of China Tour (Premium) – JT Travel China Insurance plan 3',
    'intro.name.医疗运送和送返': 'Medical assistance evacuation and repatriation',
    'intro.name.身故遗体送返': 'Repatriation of remains (funeral expenses limited to RMB20,000)',
    'intro.name.亲友慰问探访费用': 'Compassionate visit',
    'intro.name.意外身故及伤残': 'Accidental Death and Disability',
    'intro.name.意外事故及残疾': 'Accidental Death and Disability',
    'intro.name.医疗费用补偿（含意外及急性病）': 'Medical Expense Reimbursement (Including Accidental Injury and acute illness)',
    'intro.name.医疗费用补贴（含意外及急性病）': 'Medical Expense Reimbursement (Including Accidental Injury and acute illness)',
    'intro.name.每日住院津贴（30日为限）': 'Daily hospital allowance (30 days limited)',
    'intro.name.盗刷盗用账户资金损失': 'Loss of funds from stolen and embezzled accounts',
    'intro.name.盗刷滥用账户资金损失': 'Loss of funds from stolen and embezzled accounts',
    'intro.name.个人钱财损失': 'Loss of personal money',
    'intro.name.旅行证件损失': 'Loss of travel documents',
    'channel.默认渠道': 'Default Channel',
    'channel.用户自助购买': 'Self-Service Purchase',
    'sale.summary.totalQty': 'Total Quantity',
    'sale.summary.totalAmount': 'Total Amount Due',
    'sale.summary.submit': 'Submit Order',
    'sale.summary.listTitle': 'Insured List',
    'sale.agree.prefix': 'I have read the rescue service list and agree to the complimentary insurance coverage (if any) and agree to',
    'sale.agree.insureClause': 'Insurance Clauses',
    'sale.agree.rescueDetail': 'Rescue Benefit Details',
    'sale.agree.healthDetail': 'Health Benefit Details',
    'sale.agree.detail': 'Details',
    'sale.agree.empty': 'No content',
    'sale.agree.loadFail': 'Failed to load notice',
    'sale.agree.requireCheck': 'Please check to confirm you have read the notices',
    'sale.agree.openPdf': 'Open in new tab',
    'sale.agree.invalidLink': 'Unable to open this link',
    'sale.summary.listCount': 'Total {n}',
    'sale.confirm.title': 'Confirm Submit',
    'sale.confirm.listTitle': 'Sales List',
    'sale.confirm.totalQty': 'Current Total Quantity',
    'sale.confirm.standardAmount': 'Standard Sales Amount',
    'sale.confirm.noChange': 'Cannot be changed after confirmation',
    'sale.purchaseSuccess.title': 'Purchase Successful',
    'sale.purchaseSuccess.desc': 'Your order has been submitted. You can view details in Order History.',
    'sale.purchaseSuccess.viewOrder': 'View Order',
    'sale.billing.title': 'Consumer Information',
    'sale.billing.firstName': 'First Name',
    'sale.billing.firstNamePh': 'Enter first name',
    'sale.billing.firstNameRequired': 'Please enter first name',
    'sale.billing.lastName': 'Last Name',
    'sale.billing.lastNamePh': 'Enter last name',
    'sale.billing.lastNameRequired': 'Please enter last name',
    'sale.billing.email': 'Email',
    'sale.billing.emailPh': 'Enter email',
    'sale.billing.emailRequired': 'Please enter email',
    'sale.billing.emailInvalid': 'Please enter a valid email',
    'sale.billing.phone': 'Phone',
    'sale.billing.phonePh': 'Enter phone number',
    'sale.billing.phoneRequired': 'Please enter phone number',
    'sale.common.yuan': 'CNY',
    'sale.common.yuanFrom': ' CNY/up',

    'sale.order.title': 'Order History',
    'sale.order.desc': 'Customer Coverage Inquiry',
    'sale.order.inquiry': 'Coverage Inquiry',
    'sale.order.saleTime': 'Sales Date',
    'sale.order.settleStatus': 'Settlement Status',
    'sale.order.channel': 'Sales Channel',
    'sale.order.visaCenter': 'Visa Center',
    'sale.order.payType': 'Payment Method',
    'sale.order.search': 'Search',
    'sale.order.export': 'Export',
    'sale.order.list': 'Order List',
    'sale.order.total': '{n} Items in Total',
    'sale.common.all': 'all',
    'sale.common.unsettled': 'Unsettled',
    'sale.common.settled': 'Settled',
    'sale.common.startDate': 'Start Date',
    'sale.common.endDate': 'End Date',
    'sale.common.none': 'None',
    'sale.common.unitGe': '',
    'sale.common.loading': 'Loading...',
    'sale.common.to': 'To',
    'sale.common.empty': 'No Data Available',

    'sale.customer.title': 'Customers',
    'sale.customer.desc': 'Customer coverage query',
    'sale.customer.name': 'Name',
    'sale.customer.idNo': 'ID No.',
    'sale.customer.inputName': 'Enter name',
    'sale.customer.inputIdNo': 'Enter ID number',
    'sale.customer.list': 'Customer List',
    'sale.customer.pendingActive': 'Pending',
    'sale.customer.copyCode': 'Click to copy card number',
    'sale.customer.copyActiveUrl': 'Copy activation link',
    'sale.customer.viewQr': 'QR Code',
    'sale.customer.activated': 'Activated',
    'sale.customer.activateFirst': 'Please activate first',

    'sale.commodity.title': 'Products',
    'sale.commodity.desc': 'Contracted Products (Non-Settlement Products Only)',
    'sale.commodity.productName': 'Product Name',
    'sale.commodity.groupCode': 'Group Number',
    'sale.commodity.inputName': 'Please enter the product name',
    'sale.commodity.select': 'Please Select',
    'sale.commodity.payMode': 'Payment Mode',
    'sale.commodity.normalPay': 'Normal',
    'sale.commodity.prestore': 'Prestore',
    'sale.commodity.anonymous': 'Anonymous',
    'sale.commodity.search': 'Search',
    'sale.commodity.coverAge': 'Covered Age: ',
    'sale.commodity.noLimit': 'No limit',
    'sale.commodity.within': ' and under',
    'sale.commodity.coverDate': 'Coverage Period ',
    'sale.commodity.fee': 'Price ',
    'sale.commodity.feeValue': 'CNY {n}',
    'sale.commodity.channelSelect': 'Channel Selection',
    'sale.commodity.downloadQr': 'Download QR Code',
    'sale.commodity.qrFileName': 'Purchase QR Code',
    'sale.commodity.unitYear': ' Year',
    'sale.commodity.unitMonth': ' Month',
    'sale.commodity.unitDay': ' Day',
    'sale.commodity.expired': 'Expired',
    'sale.commodity.expiredTag': '(Expired)',
    'sale.commodity.deadline': 'Deadline: ',
    'sale.commodity.remainCount': 'Remaining: ',
    'sale.commodity.unitZhang': '',
    'sale.commodity.empty': 'No contracted products',
    'commodity.name.魅力中国游（优选版）-江泰救援入境旅行救援服务清单': 'Charm of China Tour (Preferred) - JT Travel China Insurance',
    'commodity.name.魅力中国游（尊享版）-江泰救援入境旅行救援服务清单': 'Charm of China Tour (Premium) - JT Travel China Insurance',
    'commodity.name.魅力中国游（优选版）-江泰救援入境旅行救援服': 'Charm of China Tour (Preferred) - JT Travel China Insurance',
    'commodity.name.魅力中国游（优选版）-江泰救援入境旅行救援服务清单方案1': 'Charm of China Tour (Preferred) – JT Travel China Insurance plan 1',
    'commodity.name.魅力中国游（优选版）-江泰救援入境旅行救援服务清单方案2': 'Charm of China Tour (Preferred) – JT Travel China Insurance plan 2',
    'commodity.name.魅力中国游（优选版）-江泰救援入境旅行救援服务清单方案3': 'Charm of China Tour (Preferred) – JT Travel China Insurance plan 3',
    'commodity.name.魅力中国游（尊享版）-江泰救援入境旅行救援服务清单方案1': 'Charm of China Tour (Premium) – JT Travel China Insurance plan 1',
    'commodity.name.魅力中国游（尊享版）-江泰救援入境旅行救援服务清单方案2': 'Charm of China Tour (Premium) – JT Travel China Insurance plan 2',
    'commodity.name.魅力中国游（尊享版）-江泰救援入境旅行救援服务清单方案3': 'Charm of China Tour (Premium) – JT Travel China Insurance plan 3',
    'commodity.name.魅力中国游 (优选版）-江泰救援入境旅行救援服务清单方案1': 'Charm of China Tour (Preferred) – JT Travel China Insurance plan 1',
    'commodity.name.魅力中国游 (优选版）-江泰救援入境旅行救援服务清单方案2': 'Charm of China Tour (Preferred) – JT Travel China Insurance plan 2',
    'commodity.name.魅力中国游 (优选版）-江泰救援入境旅行救援服务清单方案3': 'Charm of China Tour (Preferred) – JT Travel China Insurance plan 3',
    'commodity.name.魅力中国游 (尊享版）-江泰救援入境旅行救援服务清单方案1': 'Charm of China Tour (Premium) – JT Travel China Insurance plan 1',
    'commodity.name.魅力中国游 (尊享版）-江泰救援入境旅行救援服务清单方案2': 'Charm of China Tour (Premium) – JT Travel China Insurance plan 2',
    'commodity.name.魅力中国游 (尊享版）-江泰救援入境旅行救援服务清单方案3': 'Charm of China Tour (Premium) – JT Travel China Insurance plan 3',
    'commodity.name.魅力中国游优选版入境旅行救援服务清单方案一': 'Charm of China Tour (Preferred) – JT Travel China Insurance plan 1',
    'commodity.name.魅力中国游优选版入境旅行救援服务清单方案二': 'Charm of China Tour (Preferred) – JT Travel China Insurance plan 2',
    'commodity.name.魅力中国游优选版入境旅行救援服务清单方案三': 'Charm of China Tour (Preferred) – JT Travel China Insurance plan 3',
    'commodity.name.魅力中国游尊享版入境旅行救援服务清单方案一': 'Charm of China Tour (Premium) – JT Travel China Insurance plan 1',
    'commodity.name.魅力中国游尊享版入境旅行救援服务清单方案二': 'Charm of China Tour (Premium) – JT Travel China Insurance plan 2',
    'commodity.name.魅力中国游尊享版入境旅行救援服务清单方案三': 'Charm of China Tour (Premium) – JT Travel China Insurance plan 3',

    'sale.detail.title': 'Order Detail',
    'sale.detail.batch': 'Batch: ',
    'sale.detail.back': 'Back',
    'sale.detail.orderInfo': 'Order Info',
    'sale.detail.coverage': 'Coverage Details',
    'sale.detail.seller': 'Seller',
    'sale.detail.productList': 'Product',
    'sale.detail.financeStatus': 'Finance Status',
    'sale.detail.saleTime': 'Sale Time',
    'sale.detail.orderNo': 'Order No.',
    'sale.detail.buyQty': 'Quantity',
    'sale.detail.referrer': 'Referrer',
    'sale.detail.decorationCo': 'Decoration Co.',
    'sale.detail.decorationAddr': 'Decoration Addr.',
    'sale.detail.houseNo': 'House No.',
    'sale.detail.contractAmount': 'Contract Amount',
    'sale.detail.download': 'Download',
    'sale.detail.groupCredential': 'Group Certificate',
    'sale.detail.groupCredentialEdit': 'Group Certificate (Endorse)',
    'sale.detail.groupCredentialReduce': 'Group Certificate (Reduce)',
    'sale.detail.credentialType': 'Certificate Type',
    'sale.detail.genDate': 'Generated At',

    'col.index': 'No.',
    'col.id': 'ID',
    'col.name': 'Name',
    'col.insuredName': 'Insured',
    'col.userName': 'Name',
    'col.mobile': 'Mobile',
    'col.idNo': 'ID No.',
    'col.idInfo': 'ID Info',
    'col.birthday': 'Birthday',
    'col.sex': 'Gender',
    'col.email': 'Email',
    'col.flightNo': 'Flight/Train No.',
    'col.flightNo2': 'Flight/Train No.',
    'col.op': 'Actions',
    'col.days': 'Days',
    'col.activateDate': 'Travel Start Time',
    'col.entryTime': 'Entry into Mainland China',
    'col.leaveTime': 'Departure from Mainland China',
    'col.validFrom': 'Coverage Start',
    'col.validUtil': 'Coverage End',
    'col.insuranceStart': 'Policy Start',
    'col.country': 'Country',
    'col.product': 'Product',
    'col.productName': 'Product',
    'col.qty': 'Quantity',
    'col.orderNo': 'Order Number',
    'col.channel': 'Channel',
    'col.amount': 'Payment Amount',
    'col.payMethod': 'Payment Method',
    'col.status': 'Status',
    'col.createTime': 'Issue Date',
    'col.cardNo': 'Card No.',
    'col.policyNo': 'Policy No.',
    'col.activateUrl': 'Activation',
    'col.company': 'Sub-company',
    'col.insureName': 'Policyholder',
    'col.project': 'Project',
    'col.occupation': 'Occupation',
    'col.month': 'Month',
    'col.remark': 'Remark',
    'col.startPeriod': 'Start',
    'col.endPeriod': 'End',
    'col.amountYuan': 'Amount (CNY)',
    'col.userNameShort': 'Name',
    'col.idNoShort': 'ID No.',

    'op.detail': 'Details',
    'op.refund': 'Refund',
    'op.viewCredential': 'Certificate',
    'op.genCredential': 'Generating...',
    'op.generating': 'Generating',
    'op.downloadCredential': 'Download',
    'op.edit': 'Edit',
    'op.delete': 'Delete',
    'op.view': 'View',
    'op.submit': 'Submit',
    'op.cancel': 'Cancel',
    'op.confirm': 'OK',
    'op.modify': 'Edit',
    'op.refresh': 'Refresh',

    'dialog.tip': 'Notice',
    'dialog.friendTip': 'Tip',
    'dialog.confirmRefund': 'Confirm refund?',
    'dialog.refundSuccess': 'Refund successful!',
    'dialog.refundFail': 'Refund failed!',
    'dialog.refundPartialFail': 'Partial refund failed!',
    'dialog.refundActivatedFail': 'Activated card cannot be refunded!',
    'dialog.qrcode': 'QR Code',
    'dialog.payMethod': 'Payment Method',
    'dialog.selectPayMethod': 'Please select the payment method for this order',
    'dialog.orderConfirm': 'Order Confirmation',
    'dialog.repeatInfo': 'Duplicate Info',
    'dialog.confirmDelete': 'Confirm Delete',
    'dialog.deleteWarn': 'This cannot be undone.',
    'dialog.adjustAmount': 'Adjust Amount',
    'dialog.credentialDownload': 'Download Certificate',
    'dialog.addInsured': 'Add Insured',
    'dialog.editInfo': 'Edit Info',
    'dialog.warning': 'Warning',

    'form.userName': 'Name:',
    'form.travelType': 'Travel Type:',
    'form.flight': 'Flight',
    'form.train': 'Train',
    'form.resident': 'Residence:',
    'form.residentPh': 'Enter residence',
    'form.flightPh': 'Single trip coverage only',
    'form.mobile': 'Mobile:',
    'form.mobilePh': 'Enter mobile number',
    'form.idType': 'ID Type:',
    'form.idNo': 'ID No.:',
    'form.idNoPh': 'Enter passport or other ID number',
    'form.birthday': 'Birthday:',
    'form.activateDate': 'Travel Start Time:',
    'form.entryTime': 'Entry into Mainland China:',
    'form.entryTimePh': 'Select entry into Mainland China time',
    'form.leaveTime': 'Departure from Mainland China:',
    'form.leaveTimePh': 'Select departure from Mainland China time',
    'form.borderTimeNote': 'Note: Mainland China (excl. HK/Macao/Taiwan)',
    'form.selectDate': 'Select date',
    'form.days': 'Days:',
    'form.daysPh': 'Enter days',
    'form.sex': 'Gender:',
    'form.male': 'Male',
    'form.female': 'Female',
    'form.email': 'Email',
    'form.emailPh': 'Enter email',
    'form.emailRequired': 'Email is required',
    'form.emailInvalid': 'Please enter a valid email',
    'form.select': 'Please select',
    'form.userNamePh': 'Enter name',
    'form.userNameRequired': 'Name is required',
    'form.travelTypeRequired': 'Travel type is required',
    'form.residentRequired': 'Residence is required',
    'form.flightNoRequired': 'Flight/train number is required',
    'form.mobileRequired': 'Mobile number is required',
    'form.idTypeRequired': 'ID type is required',
    'form.idNoRequired': 'ID number is required',
    'form.birthdayRequired': 'Birthday is required',
    'form.dateRequired': 'Date is required',
    'form.daysRequired': 'Days are required',
    'form.entryTimeRequired': 'Please select entry into Mainland China time',
    'form.leaveTimeRequired': 'Please select departure from Mainland China time',
    'form.sexRequired': 'Gender is required',
    'form.otherRequired': 'Other is required',
    'form.sexIdMismatch': 'Gender does not match ID document',
    'form.idNoInvalid': 'Invalid ID document number, please check and re-enter',
    'form.addSuccess': 'Added successfully',
    'form.travelStartAfterEntry': 'Travel start time must be earlier than or equal to entry into Mainland China time',
    'form.selectedDaysExceedTravelSpan': 'Selected days must be greater than or equal to the inclusive range from travel start to Mainland China departure ({n} days including both dates).',
    'form.leaveTimeBeforeTravel': 'Mainland China departure date cannot be earlier than the travel start date.',
    'form.daysMin': 'Cannot be less than {n}{unit}',
    'form.daysMax': 'Cannot exceed {n}{unit}',
    'form.daysMaxDays': 'Cannot exceed {n} days',
    'form.daysPlanRange': 'Days must be between {min}-{max} days',
    'form.idFormatInvalid': 'Invalid ID document format, please re-enter',
    'form.idAreaInvalid': 'Invalid ID document area code, please re-enter',
    'form.idBirthdayInvalid': 'Invalid ID document birth date, please re-enter',
    'form.idCheckDigitInvalid': 'Invalid ID document check digit, please re-enter',
    'form.company': 'Sub-company:',
    'form.companyPh': 'Enter sub-company',
    'form.insureName': 'Policyholder:',
    'form.insureNamePh': 'Enter policyholder',
    'form.project': 'Project:',
    'form.projectPh': 'Enter project name',
    'form.occupation': 'Occupation:',
    'form.occupationPh': 'Occupation',
    'form.month': 'Month:',
    'form.monthPh': 'Insurance month',
    'form.remark': 'Remark:',
    'form.remarkPh': 'Remark',
    'form.batchName': 'Batch Name',
    'form.channel': 'Channel',
    'form.flightNoLabel': 'Flight/Train No.:',

    'idType.1': 'ID Card',
    'idType.3': 'Passport',
    'idType.6': 'Mainland Travel Permit / Tai Bao Zheng',
    'idType.9': 'HK/Macau/Taiwan Permit',
    'idType.10': 'HK/Macau Permit',
    'idType.11': 'Taiwan Travel Permit',
    'idType.4': 'Other',

    'pay.alipay': 'Alipay',
    'pay.wechat': 'WeChat Pay',
    'pay.offline': 'Offline Payment',
    'pay.prestore': 'Pay with Balance',
    'pay.normal': 'Normal Pay',
    'pay.immediate': 'Direct Payment',
    'pay.transfer': 'Offline Payment',
    'pay.offlineTransfer': 'Offline Transfer',
    'pay.wechatPay': 'WeChat Pay',
    'pay.alipayPay': 'Alipay',
    'pay.amountDue': 'Amount due: ',
    'pay.yuan': '',
    'pay.wechatPayTip': 'Please complete payment with WeChat',
    'pay.alipayPayTip': 'Please complete payment with Alipay',
    'pay.validFromAbnormal': 'Please check whether the coverage start time is valid',
    'pay.rechargeNoStack': 'Recharge methods cannot be used together',
    'pay.insufficientBalance': 'Insufficient balance',
    'pay.ageOutOfRange': 'Age is outside the coverage range',
    'pay.benefitAlreadyClaimed': 'Benefit already claimed and cannot be claimed again',
    'pay.checkPrestoreAccount': 'Please verify your prepaid account balance and information.',
    'pay.refundAuditing': 'Account refund is under review',
    'pay.paramError': 'Parameter error',
    'pay.benefitSuccess': 'Benefit obtained successfully',
    'pay.gift': 'Complimentary',
    'pay.split': 'Real-time Split',
    'pay.online': 'Online Payment',

    'billing.0': 'Sold',
    'billing.1': 'Online Paid',
    'billing.2': 'Monthly Unpaid',
    'billing.3': 'Offline Paid',
    'billing.4': 'Refunded',
    'billing.5': 'Failed Refund',
    'billing.5b': 'Failed-Refund'
  }
}



// WEBPACK FOOTER //
// ./src/i18n/messages.js